import { useMemo } from 'react';
import { TrayBarcodeAssignment } from 'api/models/Users';
import { LOCATION_SETTING_OPERATOR_ROLES, useLocationSetting } from './useLocationSetting';

export const useTrayBarcodeAssignmentSetting = () => {
  const {
    value: trayBarcodeAssignmentSetting,
    setValue: setTrayBarcodeAssignmentSetting,
    isLoading,
    canUpdate,
  } = useLocationSetting<TrayBarcodeAssignment>('tray_barcode_assignment', TrayBarcodeAssignment.Generate, {
    roles: LOCATION_SETTING_OPERATOR_ROLES,
  });

  return useMemo(
    () => ({
      trayBarcodeAssignmentSetting,
      setTrayBarcodeAssignmentSetting,
      isLoading,
      canUpdate,
      generateTrayBarcode: (deliveryId: number | string, trayReference?: number, defaultValue?: string) =>
        trayBarcodeAssignmentSetting == TrayBarcodeAssignment.Disabled || !trayReference
          ? undefined
          : trayBarcodeAssignmentSetting == TrayBarcodeAssignment.Generate
          ? `SAVI-${deliveryId}-${trayReference}`
          : defaultValue,
    }),
    [trayBarcodeAssignmentSetting, setTrayBarcodeAssignmentSetting, isLoading, canUpdate],
  );
};
